import React from 'react';
import type { ParetoSeries } from '../../utils/pareto';

function formatPercent(value: number): string {
  return `${new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 }).format(value)}%`;
}

export const ParetoChart: React.FC<{
  title: string;
  series: ParetoSeries;
  formatValue: (value: number) => string;
}> = ({ title, series, formatValue }) => (
  <section className="rounded-md border border-slate-200 px-3 py-2 dark:border-slate-800">
    <h3 className="text-[12px] font-semibold text-slate-900 dark:text-slate-50">Pareto · {title}</h3>
    <ol className="mt-2 space-y-2">
      {series.bars.map((bar) => (
        <li key={bar.id}>
          <div className="flex items-baseline justify-between gap-3 text-[12px] text-slate-700 dark:text-slate-200">
            <span className="min-w-0 truncate font-medium">{bar.label}</span>
            <span className="shrink-0 tabular-nums text-slate-500">
              {formatValue(bar.value)} · {formatPercent(bar.percent)} · acum. {formatPercent(bar.cumulative)}
            </span>
          </div>
          <div className="mt-1 h-1.5 rounded bg-slate-100 dark:bg-slate-800">
            <div className="h-1.5 rounded bg-slate-800 dark:bg-slate-200" style={{ width: `${Math.min(100, bar.percent)}%` }} />
          </div>
        </li>
      ))}
    </ol>
  </section>
);
